import React, { useRef, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import '../../../scss/components/_signal_planning.scss';
import API_PATH from "../../../constants/config.json";
const API_URL = process.env.REACT_APP_BASE_URL;
const axios = require('axios');

const MovAnalysisTable = props => {

    const [sumLaneMov, setSumLaneMov] = useState(0);
    const [criticalFlowRatio, setCriticalFlowRatio] = useState(0);

    useEffect(() => {
        if(props.activeData) {
            let sum = 0;
            let dir = ['NB', 'SB', 'EB', 'WB'];
            dir.forEach(function(d) {
                sum += props.criticalLaneVol && props.criticalLaneVol[d+'Left'] ? props.criticalLaneVol[d+'Left'] : 0;
                sum += props.criticalLaneVol && props.criticalLaneVol[d+'Thru'] ? props.criticalLaneVol[d+'Thru'] : 0;
                sum += props.criticalLaneVol && props.criticalLaneVol[d+'Right'] ? props.criticalLaneVol[d+'Right'] : 0;
            });
            sum = Math.round(sum);
            setSumLaneMov(sum);
            props.setSumLaneVolumes(sum);
            let ratio = props.intCapacity>0 ? (sum/props.intCapacity).toFixed(2) : 0;
            setCriticalFlowRatio(ratio);
            props.setCapacityAssessment(ratio);
        }
    }, [props.activeData, props.criticalLaneVol, props.intCapacity, props.capacityRatioCat])
    
    

    return (
        <div className='analysis-cnt'>
            <div className='calc-section no-mb'>
                <label>Critical movement analysis results</label>
                <table cellSpacing={0} className={props.editable ? "editable-table" : null}>
                    <tr>
                        <td className='b-bottom b-right-dark odd' width="212px">Sum critical lane volumes</td>
                        <td className='b-bottom b-right odd' width="256px">{props.activeData ? sumLaneMov : ""}</td>
                    </tr>
                    <tr>
                        <td className='b-bottom b-right-dark'>Intersection capacity</td>
                        <td className='editable b-bottom b-right'><input type='text' value={props.intCapacity} onChange={(e) => props.setIntCapacity(e.target.value)} /></td>
                    </tr>
                    <tr>
                        <td className='b-bottom b-right-dark odd'>Critical flow ratio</td>
                        <td className='b-bottom b-right odd'>{props.activeData ? criticalFlowRatio : ""}</td>
                    </tr>
                    <tr>
                        <td className='b-bottom b-right-dark'>Capacity assessment</td>
                        <td className='b-bottom b-right'>
                            <label className={props.capacityAssessment < 0.85 ? 'margin-0  emerald-txt' : props.capacityAssessment >= 0.85 && props.capacityAssessment <= 0.98 ? 'margin-0 amber-txt' : 'margin-0 red-txt'}>
                                {props.capacityAssessment < 0.85 ? 'Under capacity' : props.capacityAssessment >= 0.85 && props.capacityAssessment <= 0.98 ? 'Near capacity' : 'Over capacity'}
                            </label>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='calc-section no-mb'>
                <label>Critical intersection volume-to-capacity ratio</label>
                <div className='capacity-levels'>
                    {
                        props.capacityRatioCat.map((item, ind)=> (
                            <div className={ind !== 1 ? 'odd' : ""}>
                                <label>{ind === 0 ? "<"+item['max'] : ind === 1 ? item['min']+"-"+item['max'] : ">"+item['min']}</label>
                                <label>{item['description']}</label>
                                <label className={ind===0 ? 'emerald-txt': ind===1 ? 'amber-txt' : 'red-txt'}>{item['capacity']}</label>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )

}

export default MovAnalysisTable;